import { Comment, Fragment, isVNode, Slot, VNodeArrayChildren } from 'vue';

// Note: It was previously sufficient to check !!this.$slots.slotName to determine if the slot was populated.
// It is now necessary to check that the slot is available as well as containing valid Vue nodes.
function isSlotPopulated(targetSlot: Slot | undefined): boolean {
  if (targetSlot === undefined) {
    return false;
  }
  const slotContents: VNodeArrayChildren = targetSlot();
  return isValid(slotContents);
}

function isValid(nodes: VNodeArrayChildren) {
  return nodes.some(node => {
    if (!isVNode(node)) {
      return true;
    }
    if (node.type === Comment) {
      return false;
    }
    if (node.type === Fragment && !isValid(node.children as VNodeArrayChildren)) {
      return false;
    }
    return true;
  });
}

export { isSlotPopulated };
